<div class="text-white text-center fixed-bottom bg-primary py-1 maintenance-footer" *ngIf="_utilsService.isMaintenance">
  <!-- Today or Tomorrow Maintenance -->
  <span
    class="mr-3"
    *ngIf="
      Number(this._utilsService.formatDate(this._utilsService.themeConfiguration.maintenance_start, 'DD')) === this.currentDay ||
        Number(this._utilsService.formatDate(this._utilsService.themeConfiguration.maintenance_start, 'DD')) === this.currentDay + 1;
      else elseBlock
    "
  >
    {{ "THERE_IS_A_MAINTENANCE" | translate }} {{ _utilsService.formatDate(_utilsService.themeConfiguration.maintenance_start, "DD") == currentDay ? ("TODAY" | translate) : ("TOMORROW" | translate) }}
    {{ "HOUR_FROM" | translate | lowercase }}
    {{ _utilsService.formatDate(_utilsService.themeConfiguration.maintenance_start, "HH:mm") }}
    {{ "HOUR_TO" | translate | lowercase }}
    {{ _utilsService.formatDate(_utilsService.themeConfiguration.maintenance_end, " HH:mm") }}
  </span>
  <!-- After tomorrow maintenance-->

  <ng-template class="mr-3" #elseBlock>
    {{ "THERE_IS_A_MAINTENANCE" | translate }} {{ "THE_MASCULIN" | translate }} {{ _utilsService.formatDate(_utilsService.themeConfiguration.maintenance_start, "DD/MM") }}
    {{ "HOUR_FROM" | translate | lowercase }}
    {{ _utilsService.formatDate(_utilsService.themeConfiguration.maintenance_start, "HH:mm") }}
    {{ "HOUR_TO" | translate | lowercase }}
    {{ _utilsService.formatDate(_utilsService.themeConfiguration.maintenance_end, " HH:mm") }} {{ "OF_THE" | translate }} {{ _utilsService.formatDate(_utilsService.themeConfiguration.maintenance_end, "DD/MM") }}
  </ng-template>
  <span> v.{{ getVersion() }} - Made with <span [data-feather]="'heart'" [class]="'orange'"></span> </span>
</div>
<!-- Footer -->
<p class="clearfix mb-0" [ngClass.xl]="'container'">
  <span class="float-md-left d-block d-md-inline-block mt-25">
    Copyright &copy; {{ year }} <a class="ml-25" href="https://nepta.it" target="_blank">{{ coreConfig.custom.corporate_name }}</a> <span class="d-none d-sm-inline-block">. {{ "ALL_RIGHTS_RESERVED" | translate }}</span>
  </span>
  <span class="float-md-right d-none d-md-block"> v.{{ getVersion() }} - Made with <span [data-feather]="'heart'" [class]="'orange'"></span> </span>
</p>
<!--/ Footer -->

<!-- Move to top Button-->
<app-scroll-top *ngIf="coreConfig.layout.scrollTop"></app-scroll-top>
